import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import * as groupBy from 'lodash/groupBy';
import { Router } from '@angular/router';
import { Airport } from '../models/airport.model';
import { LandingSurfaceType } from '../models/landing-surface.model';
import { CommentType } from '../models/airport-comment.model';
import { SearchQuery } from '../../search/models/search-query.model';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../../shared/user/user.service';
import { State } from '../../shared/state-view/state.model';
import { Source } from '../../shared/models/source.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditGaTransientComponent } from '../edit-ga-transient/edit-ga-transient.component';
import { AirportService } from '../airport.service';
import * as moment from 'moment-timezone';
// import * as SunCalc from 'suncalc';
/**
 * Radius (in nautical miles) to use for nearby airport search.
 */
export var NEARBY_RADIUS = 25;
var AirportOverviewComponent = /** @class */ (function () {
    function AirportOverviewComponent(_decimalPipe, _auth, _userService, _toggleService, _snackBar, _editGATransientDialog, _airportService, _router) {
        var _this = this;
        this._decimalPipe = _decimalPipe;
        this._auth = _auth;
        this._userService = _userService;
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editGATransientDialog = _editGATransientDialog;
        this._airportService = _airportService;
        this._router = _router;
        this.authenticated = false;
        this.state = State.Empty;
        this.Source = Source;
        this.editModeSet = false;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    }
    AirportOverviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Update state based on latest event in authStream, and subscribe to any future
        // changes in authentication state.
        this._onAuthEvent(this._auth.authStream.getValue());
        this._auth.authStream.subscribe(function (e) { return _this._onAuthEvent(e); });
        // Update state based on latest available userInfo, and subscribe to any future
        // changes to userInfo.
        this._userInfo = this._userService.userInfo.getValue();
        this._userService.userInfo.subscribe(function (u) {
            // Update userInfo
            _this._userInfo = u;
            // Set state to loaded
            _this.state = State.Content;
        });
    };
    AirportOverviewComponent.prototype._onAuthEvent = function (e) {
        this.authenticated = this._auth.authenticated;
        if (this.authenticated && !this._auth.endUser) {
            // userInfo is not available when not authenticated as an end user, so set favorite state to loaded now.
            this.state = State.Content;
        }
    };
    Object.defineProperty(AirportOverviewComponent.prototype, "elevationMethod", {
        get: function () {
            if (this.airport.elevationMethod !== null) {
                return Airport.formatElevationMethod(this.airport.elevationMethod);
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "fbos", {
        get: function () {
            return this.airport.businesses.filter(function (a) { return a.isFbo; })
                .filter(function (fbo) { return !fbo.hideBusiness; })
                .filter(function (fbo) { return !fbo.notApproved; })
                .sort(function (bs1, bs2) {
                return bs1.name < bs2.name ? -1 : bs1.name > bs2.name ? 1 : 0;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "towerFacilityType", {
        get: function () {
            if (this.airport.towerFacilityType !== null) {
                return Airport.formatTowerFacilityType(this.airport.towerFacilityType);
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "attendanceRemarks", {
        /**
         * Returns list of attendance remarks that apply to this airport.
         */
        get: function () {
            return this.airport.getComments(CommentType.Attendance);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "towerRemarks", {
        /**
         * Returns list of tower remarks that apply to this airport.
         * @returns {Array<AirportComment>}
         */
        get: function () {
            return this.airport.getComments(CommentType.Tower);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "runways", {
        /**
         * Returns the airport runways, sorted by runway length in descending order
         */
        get: function () {
            if (!this.airport || !this.airport.landingSurfaces) {
                return null;
            }
            return this.airport.landingSurfaces.sort(function (rwy1, rwy2) {
                if (!rwy2.length) {
                    return -1;
                }
                return rwy2.length - rwy1.length;
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "towerText", {
        /**
         * Returns the text to display for the "Tower" field if the airport is towered.
         * @returns {string}
         */
        get: function () {
            return [
                Airport.formatTowerFacilityType(this.airport.towerFacilityType),
                this.airport.towerHrsPerDay ? this.airport.towerHrsPerDay + ' hrs/day' : null,
                this.airport.towerRegularityOfOps
            ].filter(function (v) { return v; }).join(', ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "fees", {
        /**
         * Returns fees that are applicable to this airport.
         */
        get: function () {
            var result = [];
            var hasOther = false;
            var feesWanted = ['Ramp', 'Hangar', 'Tie Down', 'Landing', 'Overnight', 'Handling', 'Parking'];
            if (this.airport.businesses != null) {
                for (var _i = 0, _a = this.airport.businessFees; _i < _a.length; _i++) {
                    var busFee = _a[_i];
                    for (var _b = 0, feesWanted_1 = feesWanted; _b < feesWanted_1.length; _b++) {
                        var currentFee = feesWanted_1[_b];
                        if (busFee === currentFee) {
                            result.push(busFee);
                        }
                        else {
                            hasOther = true;
                        }
                    }
                }
            }
            //  Filters array by uniqueness
            result = result.filter(function (value, i, self) { return self.indexOf(value) === i; }).sort();
            if (hasOther) {
                result.push('Other');
            }
            return result.join(', ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "allFuel", {
        /**
         * Returns an array of all fuel types available at any FBO at this airport.
         */
        get: function () {
            return [].concat.apply([], this.airport.businesses.map(function (b) { return b.fuel; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "minimumFuelPrices", {
        /**
         * Returns the minimum fuel prices for each combination of fuel and service type.
         */
        get: function () {
            var groups = groupBy(this.allFuel, function (f) {
                return f.fuelType + '|' + f.service;
            });
            var retVal = [];
            /* return Object.values(groups)
              .map(fuelPrices => fuelPrices.sort((f1: BusinessFuel, f2: BusinessFuel) => f1.price - f2.price)[0]); */
            var groupValues = Object.values(groups);
            for (var _i = 0, groupValues_1 = groupValues; _i < groupValues_1.length; _i++) {
                var fuelType = groupValues_1[_i];
                var fuelTypeArray = fuelType;
                fuelTypeArray.sort(function (f1, f2) { return f1.price - f2.price; });
                retVal.push(fuelTypeArray[0]);
            }
            // const retVal = Object.values(groups).map(fuelPrices => fuelPrices[0]);
            return retVal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "longestRunwayText", {
        /**
         * Returns the text to display for the longest runway length. The logic is based on the following:
         *   - If there are no runways, return an empty string.
         *   - If there is only one runway, just show "Runway Length".
         *   - If there is a mix of paved and unpaved runways, show the longest paved runway.
         *   - If there are no paved runways, just show the longest (unpaved) runway length.
         */
        get: function () {
            var _this = this;
            var formatNumber = function (value) { return _this._decimalPipe.transform(value); };
            var rwyCompareFn = function (rwy1, rwy2) { return rwy2.length - rwy1.length; };
            var runways = this.airport.landingSurfaces.filter(function (rwy) { return rwy.type === LandingSurfaceType.Runway; });
            if (runways.length < 1) {
                return '';
            }
            if (runways.length === 1) {
                return "Runway length: " + formatNumber(runways[0].length) + " ft\n" + "(" + formatNumber(runways[0].lengthMeters) + " m)";
            }
            var pavedRunways = runways.filter(function (rwy) { return rwy.paved; });
            if (pavedRunways.length) {
                var longestPavedRwy = pavedRunways.sort(rwyCompareFn)[0];
                return "Longest paved runway: " + formatNumber(longestPavedRwy.length) + " ft\n"
                    + "(" + formatNumber(longestPavedRwy.lengthMeters) + " m)";
            }
            var longestRwy = runways.sort(rwyCompareFn)[0];
            return "Longest runway: " + longestRwy.length + " ft\n" + "(" + formatNumber(longestRwy.lengthMeters) + " m)";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "nearbyParams", {
        /**
         * Query parameters for the Nearby Airports link
         */
        get: function () {
            if (!this.airport) {
                return null;
            }
            var query = new SearchQuery();
            query.location = this.airport.location;
            query.radius = NEARBY_RADIUS;
            return query.encode();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "favoriteValid", {
        get: function () {
            return this._userInfo && this._userInfo.favoriteAirports.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "validationReason", {
        get: function () {
            if (!this._userInfo) {
                return 'Please log in to use this feature.';
            }
            if (this._userInfo.favoriteAirports.length < 1) {
                return 'Add airports to your favorites list to use this feature.';
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "notSubscribedTooltip", {
        get: function () {
            if (!this.isIsland || this.isSubscribedToIslandGuide) {
                return '';
            }
            return 'Island Guide subscribers only';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "transientRamp", {
        get: function () {
            if (this.airport.afmOther !== null) {
                if (this.airport.afmOther.gatParking === null) {
                    return 'Unknown';
                }
                else if (this.airport.afmOther.gatParking === false) {
                    return 'No';
                }
                else {
                    return 'Yes, ';
                }
            }
            else {
                return 'Unknown';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "timeZoneText", {
        get: function () {
            if (!this.airport || !this.airport.timeZone) {
                return null;
            }
            var timeZone = moment().tz(this.airport.timeZone);
            var UTCOffset = '(UTC' + timeZone.format('Z') + ')';
            return timeZone.format('z') + ' ' + UTCOffset;
        },
        enumerable: true,
        configurable: true
    });
    AirportOverviewComponent.prototype.getWebcamCount = function () {
        var webcamCount = this.airport.webcams.length;
        this.airport.businesses.forEach(function (business) {
            business.webcams.forEach(function (businessWebcam) {
                webcamCount++;
            });
        });
        return webcamCount;
    };
    Object.defineProperty(AirportOverviewComponent.prototype, "sunrise", {
        get: function () {
            var today = new Date();
            var times = SunCalc.getTimes(today, this.airport.location.lat, this.airport.location.lon);
            if (this.airport.timeZone != null) {
                return moment(times.sunrise).tz(this.airport.timeZone).format('h:mm a');
            }
            else {
                return moment(times.sunrise).format('h:mm a');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "sunset", {
        get: function () {
            var today = new Date();
            var times = SunCalc.getTimes(today, this.airport.location.lat, this.airport.location.lon);
            if (this.airport.timeZone != null) {
                return moment(times.sunset).tz(this.airport.timeZone).format('h:mm a');
            }
            else {
                return moment(times.sunset).format('h:mm a');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "pmCivilTwilightEnd", {
        get: function () {
            var today = new Date();
            var times = SunCalc.getTimes(today, this.airport.location.lat, this.airport.location.lon);
            if (this.airport.timeZone != null) {
                return moment(times.dusk).tz(this.airport.timeZone).format('h:mm a');
            }
            else {
                return moment(times.dusk).format('h:mm a');
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportOverviewComponent.prototype, "amCivilTwilightStart", {
        get: function () {
            var today = new Date();
            var tomorrow = today.setDate(today.getDate() + 1);
            var times = SunCalc.getTimes(tomorrow, this.airport.location.lat, this.airport.location.lon);
            if (this.airport.timeZone != null) {
                return moment(times.dawn).tz(this.airport.timeZone).format('h:mm a');
            }
            else {
                return moment(times.dawn).format('h:mm a');
            }
        },
        enumerable: true,
        configurable: true
    });
    AirportOverviewComponent.prototype.navigateToWx = function () {
        var tempUrl = this._router.url;
        if (this._router.url.indexOf('?') > 0) {
            tempUrl = this._router.url.substr(0, tempUrl.indexOf('?'));
        }
        if (this._router.url.indexOf('#') > 0) {
            tempUrl = this._router.url.substr(0, tempUrl.indexOf('#'));
        }
        this._router.navigate([tempUrl], { fragment: 'wx' });
    };
    AirportOverviewComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AirportOverviewComponent.prototype.openEditGATransientDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '60%';
        dialogConfig.data = {
            airID: this.airport.airportId,
            isNew: false,
        };
        dialogConfig.data.afmOther = this.airport.afmOther;
        dialogConfig.data['airID'] = this.airport.airportId;
        dialogConfig.width = '60%';
        var dialogRef = this._editGATransientDialog.open(EditGaTransientComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.reloadAirport(_this.airport.identifier);
                _this._snackBar.open('GA Transient Parking', 'Updated', {
                    duration: 2000
                });
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    Object.defineProperty(AirportOverviewComponent.prototype, "whyHereText", {
        get: function () {
            if (!this.airport || this.airport.airportComments.length < 1) {
                return null;
            }
            if (this.isIsland != null) {
                var comment = this.airport.airportComments.filter(function (c) { return c.commentRef === 'WhyHere'; });
                if (comment.length > 0) {
                    var whyHere = comment[0];
                    if (whyHere != null) {
                        return whyHere.text;
                    }
                }
                else {
                    return '';
                }
                return this.whyHereText;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    AirportOverviewComponent.prototype.navigateToTFRs = function () {
        var tempUrl = this._router.url;
        if (this._router.url.indexOf('?') > 0) {
            tempUrl = this._router.url.substr(0, tempUrl.indexOf('?'));
        }
        if (this._router.url.indexOf('#') > 0) {
            tempUrl = this._router.url.substr(0, tempUrl.indexOf('#'));
        }
        this._router.navigate([tempUrl], { fragment: 'notams' });
    };
    return AirportOverviewComponent;
}());
export { AirportOverviewComponent };
